<template>
  <v-row
    v-if="prop != null && !isDoseReference"
    class="ma-0 ml-2 pr-5 pa-0"
    align="center"
  >
    <div v-bind:class="getClasses" class="ma-0 pa-0 pt-1">
      <v-icon size="6" class="pb-1" color="#004662">{{ icon }}</v-icon>
      <span v-html="prop" class="ml-1"></span>
      <span v-if="references && references.length">{{ " " }}</span>
      <v-icon
        @click="setClickedReferences(references)"
        x-small
        v-if="references && references.length"
        class="vetalfa-pointer pb-1"
        color="#004662"
        >{{ mdiInformation }}
      </v-icon>
      <slot></slot>
    </div>
  </v-row>
  <vetalfa-dose-card
    isCard
    v-else-if="!!this.references"
    class="mb-4 mt-2 ma-0 pa-0"
    :isDrugsManagement="isAdmin"
    :prop="{
      ...this.references[0].dose,
      title: this.references[0].name,
      options: prop,
      path: this.references[0].path,
    }"
  ></vetalfa-dose-card>
</template>

<style>
.section-item {
  background-color: white;
  width: 100%;
  font-size: 14px;
  font-weight: 0;
  color: #393a3a;
}
.section-item-result {
  background-color: white;
  width: 100%;
  font-size: 18px;
  font-weight: 0;
  color: #393a3a;
}
.section-item-border {
  border-top: 0.5px dashed rgb(57, 58, 58, 0.4);
}
</style>

<script>
import { mdiCircle, mdiInformation } from "@mdi/js";
import { mapMutations } from "vuex";
export default {
  name: "SectionItem",
  props: {
    prop: {
      type: String,
    },
    index: {
      type: Number,
      default: 0,
    },
    result: {
      type: Boolean,
      default: false,
      required: false,
    },
    hasMargins: {
      type: Boolean,
      default: true,
      required: false,
    },
    references: {
      type: Array,
      default: null,
      required: false,
    },
  },
  computed: {
    getClasses() {
      let classes = this.index > 0 ? "section-item-border " : "";
      classes += this.hasMargins ? " ml-4 " : "";
      return classes + (this.result ? "section-item-result" : "section-item");
    },
    isDoseReference() {
      return (
        !!this.references &&
        this.references.length == 1 &&
        !!this.references[0].dose
      );
    },
    isAdmin() {
      return process.env.VUE_APP_ENV === "admin";
    },
  },
  methods: {
    ...mapMutations("topics", ["setClickedReferences"]),
  },
  data() {
    return {
      icon: mdiCircle,
      mdiInformation,
    };
  },
};
</script>